import { ReactNode } from 'react';
import { FeatureFlagKey, useFeatureFlag } from '@/providers/feature-flag-provider';

interface AccessGuardProps {
    featureFlag: FeatureFlagKey;
    children: {
        fallback: ReactNode;
        success: ReactNode;
    };
}

export const FeatureFlagGuard = ({ featureFlag, children: { success, fallback } }: AccessGuardProps) => {
    const { isEnabled } = useFeatureFlag();
    if (isEnabled(featureFlag)) {
        return success;
    }
    return fallback;
};
